export default __webpack_public_path__ + "static/media/marathi_lang.85036838.png";